import * as React from 'react';
import { IStringLocalizer } from '../../../utilities/IStringLocalizer';
import { useLocalizer } from './hooks/useLocalizer';

interface AIOverrideCheckboxProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    localizer?: IStringLocalizer;
    registerPopoversCb?: (popoverIds: string[]) => void;
}

/**
 * Checkbox component for controlling whether AI should override existing answers
 * Includes help popover explaining the functionality
 */
export const AIOverrideCheckbox: React.FC<AIOverrideCheckboxProps> = ({
    checked,
    onChange,
    disabled = false,
    localizer,
    registerPopoversCb
}) => {
    const localize = useLocalizer(localizer);

    React.useEffect(() => {
        if (registerPopoversCb) {
            setTimeout(() => {
                registerPopoversCb(['ai-override-popover']);
            }, 100);
        }
    }, [registerPopoversCb]);

    return (
        <div className="form-check" style={{ marginBottom: '15px' }}>
            <input
                type="checkbox"
                className="form-check-input"
                id="overrideExistingAnswers"
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                disabled={disabled}
            />
            <label
                className="form-check-label"
                htmlFor="overrideExistingAnswers"
                style={{ marginLeft: '7px', fontWeight: 'normal' }}
            >
                {localize("Override existing answers with AI suggestions")}
            </label>
            <a
                id="ai-override-popover"
                data-container="body"
                role="button"
                className="m-l-5"
                data-toggle="popover"
                data-html="true"
                data-placement="top"
                data-content={localize("When checked, AI-generated suggestions will replace any answers you've previously entered at a question level for all questionnaires, except CMRT where overrides are applied at a questionnaire level. When unchecked, your existing answers are preserved and AI will only fill in unanswered questions.")}
            >
                <img height="14" src="/images/help-icon-dark-gray.png" />
            </a>
        </div>
    );
};

export default AIOverrideCheckbox;
